(function () {
  var widget   = document.getElementById('muiha-sanae-widget');
  if (!widget) return;

  var toggle   = document.getElementById('muiha-sanae-toggle');
  var panel    = document.getElementById('muiha-sanae-panel');
  var closeBtn = document.getElementById('muiha-sanae-close');
  var messages = document.getElementById('muiha-sanae-messages');
  var input    = document.getElementById('muiha-sanae-input');
  var sendBtn  = document.getElementById('muiha-sanae-send');

  if (!toggle || !panel || !messages || !input) return;

  var endpoint = widget.dataset.endpoint    || '';
  var welcome  = widget.dataset.welcome     || '';
  var showMob  = widget.dataset.showMobile !== 'false';
  var mobStyle = widget.dataset.mobileStyle || 'drop';

  if (!showMob && window.innerWidth < 768) {
    widget.style.display = 'none';
    return;
  }
  if (mobStyle === 'drop') widget.classList.add('muiha-sanae-widget--drop-mobile');

  var history  = [];
  var isOpen   = false;
  var welcomed = false;

  function setOpen(open) {
    isOpen = open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden',    open ? 'false' : 'true');
    panel.classList.toggle('is-open', open);
    if (open && !welcomed && welcome) {
      welcomed = true;
      setTimeout(function () { addBubble('ai', welcome); }, 350);
    }
    if (open) { setTimeout(function () { input.focus(); }, 360); }
  }

  toggle.addEventListener('click', function () { setOpen(!isOpen); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

  document.addEventListener('click', function (e) {
    if (isOpen && !widget.contains(e.target)) setOpen(false);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });
  if (sendBtn) sendBtn.addEventListener('click', send);

  function addBubble(role, text) {
    var div = document.createElement('div');
    div.className   = 'muiha-sanae-bubble muiha-sanae-bubble--' + role;
    div.textContent = text;
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
    return div;
  }

  function showTyping() {
    var div = document.createElement('div');
    div.className = 'muiha-sanae-bubble muiha-sanae-bubble--ai muiha-sanae-typing';
    div.id        = 'muiha-sanae-typing-indicator';
    div.innerHTML = '<span></span><span></span><span></span>';
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }

  function hideTyping() {
    var el = document.getElementById('muiha-sanae-typing-indicator');
    if (el) el.parentNode.removeChild(el);
  }

  function setInputBusy(busy) {
    input.disabled = busy;
    if (sendBtn) sendBtn.disabled = busy;
  }

  function send() {
    var text = input.value.trim();
    if (!text) return;
    input.value = '';
    setInputBusy(true);
    addBubble('user', text);
    history.push({ role: 'user', content: text });
    showTyping();

    if (!endpoint) {
      setTimeout(function () {
        hideTyping();
        var msg = "I'm Sanaē, your Muiha hydration guide. The full AI experience is coming soon — in the meantime, explore Symbio+ or contact us for personalized mineral guidance.";
        addBubble('ai', msg);
        history.push({ role: 'assistant', content: msg });
        setInputBusy(false);
        input.focus();
      }, 900);
      return;
    }

    var timeoutId = setTimeout(function () {
      hideTyping();
      addBubble('ai', "Sorry, I'm unavailable right now. Please try again in a moment.");
      setInputBusy(false);
    }, 8000);

    fetch(endpoint, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        message: text,
        context: {
          page:    window.location.pathname,
          product: (window.Shopify && window.Shopify.product)
            ? window.Shopify.product.handle
            : null
        },
        history: history.slice(-6)
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('status ' + res.status);
      return res.json();
    })
    .then(function (data) {
      clearTimeout(timeoutId);
      hideTyping();
      var reply = (data && (data.reply || data.message || data.text))
        || "I didn't understand that. Could you rephrase?";
      addBubble('ai', reply);
      history.push({ role: 'assistant', content: reply });
    })
    .catch(function () {
      clearTimeout(timeoutId);
      hideTyping();
      addBubble('ai', "Sorry, I'm unavailable right now. Please try again in a moment.");
    })
    .finally(function () {
      setInputBusy(false);
      input.focus();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.contains(widget)) {
      setOpen(false);
      welcomed = false;
      history  = [];
      while (messages.firstChild) messages.removeChild(messages.firstChild);
    }
  });
})();
